import { Component } from '@angular/core';
import { NavController, ModalController, AlertController } from 'ionic-angular';
import { IonicPage, NavParams } from 'ionic-angular';
import { VariablesProvider } from '../../providers/variables/variables';
import { ViewController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { FuncionesProvider } from '../../providers/funciones/funciones';
import { Events } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'app-modal-push',
  templateUrl: './modal-push.html',
})
export class ModalPushPage {
  mensaje: string = '';

  constructor(
  	public navCtrl: NavController,
  	public fb: FormBuilder,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public params: NavParams,
    public viewCtrl: ViewController,
    public variables:VariablesProvider,
    public events: Events
    ) {}


    dismiss() {
      //console.log("Se va...");
      this.viewCtrl.dismiss(
        {
          //CODIGO DISMISS
        }
      ); }

      

  enviarPush() {
    const bear = 'TU_TOKEN_BEAR'; // reemplazar con tu lógica real
    const token = 'TOKEN_DESTINATARIO'; // también debería venir del contexto

    const url = `https://www.panel-control.com/push/pushflutter.php?bear=${bear}&token=${token}&mensaje=${encodeURIComponent(this.mensaje)}`;
    
    /*this.http.get(url).subscribe(() => {
      alert('Push enviado');
      this.cerrar();
    }, error => {
      alert('Error al enviar el push');
    });
    */
  }
}


// WEBPACK FOOTER //
// ./src/pages/modal-push/modal-push.ts